<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Project/POA/components/Budget/components/Budget/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>